// Add your custom JS here.


// Add placeholder to newsletter spotler
jQuery(document).ready(function($) {
  // Use a delay to ensure that the form is fully generated
  setTimeout(function() {
    $('#field1208').attr('placeholder', 'Enter your email address');
  }, 1000);
});


jQuery(document).ready(function() {
  function updateViewport() {
    if (window.innerWidth >= 768) {
      // Apply viewport meta tag only if screen size is larger than 768px
      jQuery('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=' + (1 / window.devicePixelRatio) + ', shrink-to-fit=no');
    } else {
      // Optional: Remove or reset the viewport meta tag content for smaller screens
      jQuery('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1.0, shrink-to-fit=no');
    }
  }

  // Initial call on document ready
  updateViewport();

  // Update viewport meta tag on window resize
  jQuery(window).resize(function() {
    updateViewport();
  });
});


// Load more posts
jQuery(document).ready(function ($) {
	jQuery(".load-more-post").slice(0, 9).show();
	jQuery("#loadMore").on("click", function (e) {
	  e.preventDefault();
	  jQuery(".load-more-post:hidden").slice(0, 3).slideDown();

	  if (jQuery(".load-more-post:hidden").length == 0) {
		jQuery("#loadMore").text("No more posts").addClass("noContent");
	  }
	});
});


jQuery(document).ready(function ($) {

  //Replace gravity form submit button
  $('#gform_submit_button_3').html('');
  $('#gform_submit_button_4').html('');

  //Slick progress bar
  $('.slidervisual').each(function () {
  var $slider = $(this);
  var $progressBar = $(this).find('.slick-progress');
  var $progressBarLabel = $(this).find( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
});
	
	//Add active class to menu if we are on that page
	$('.sub_active').each(function () {
      $(this).closest('li.menu-item').addClass('active');
    });

  //Add stlye for select placeholder in forms
  $('.gfield_select').each(function () {
  $(this).addClass('placeholder');
    $(this).change(function(){
        if ($(this).find('option:selected').hasClass('gf_placeholder')) {
            $(this).addClass('placeholder');
        } else {
            $(this).removeClass('placeholder');
        }
    });
  });

  //Swiper slider for Carousel
  var carouselSwiper = new Swiper('.carousel-container', {
      slidesPerView: 1.2, // Show 1 slide on mobile
      spaceBetween: 15,
	  pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
          nextEl: '.swiper-nav__right',
          prevEl: '.swiper-nav__left',
      },
      // Add breakpoints for responsiveness
      breakpoints: {
          576: {
              slidesPerView: 2,
          },
          992: {
              slidesPerView: 3, 
              spaceBetween: 20,
          },
          // Add more breakpoints as needed
      },
  });

  //Swiper slider for Services Carousel
  var carouselSwiper = new Swiper('.services-carousel', {
    slidesPerView: 1.2, // Show 1 slide on mobile
    spaceBetween: 10,
  pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    navigation: {
        nextEl: '.swiper-nav__right',
        prevEl: '.swiper-nav__left',
    },
    // Add breakpoints for responsiveness
    breakpoints: {
        576: {
            slidesPerView: 1.2,
        },
        992: {
            slidesPerView: 2, 
            spaceBetween: 30,
        },
        // Add more breakpoints as needed
    },
});

//Swiper slider for col block

var init = false;
var swiper;

function swiperCard() {
  $('.col-block').each(function() {
    var slideCount = $('.col-block-col', this).length;

    if (slideCount > 4) {
      if (window.innerWidth <= 768) {
        if (!init) {
          init = true;

          // Add .swiper-slide class to any .col- element within .col-slider if not already added
          $('div[class^="col-"]', this).each(function() {
            if (!$(this).hasClass('swiper-slide')) {
              $(this).addClass('swiper-slide');
            }
          });

          swiper = new Swiper('.col-block-slider', {
            slidesPerView: 1.2, // Show 1 slide on mobile
            spaceBetween: 12,
            loop: false,
            pagination: {
              el: '.swiper-pagination',
              type: 'progressbar',
            },
          });
        }
      } else if (init) {

        // Remove .swiper-slide class from any .col- element within .col-slider if screen width >= 768px
        $('div[class^="col-"]', this).each(function() {
          //if ($(this).hasClass('swiper-slide')) {
            $(this).removeClass('swiper-slide');
        //  }
        });

        // Destroy Swiper instance
        swiper.destroy();
        swiper = null;
        init = false;

        
      }
    } else {
      // Handle case when slideCount <= 4, if needed
      $('.swiper-wrapper', this).addClass('break');
    }
  });
}

// Initial check
swiperCard();

// Add resize event listener
window.addEventListener("resize", swiperCard);


  
  //Swiper slider for Products
  var acProductsSwiper = new Swiper('.carousel_ac-products', {
      slidesPerView: 1.1, // Show 1 slide on mobile
      spaceBetween: 15,
	  pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
          nextEl: '.swiper-nav__right_ac-products',
          prevEl: '.swiper-nav__left_ac-products',
      },
      // Add breakpoints for responsiveness
      breakpoints: {
          576: {
              slidesPerView: 2,
          },
          992: {
              slidesPerView: 3,
              spaceBetween: 20, 
          },
          // Add more breakpoints as needed
      },
  });
    var dcProductsSwiper = new Swiper('.carousel_dc-products', {
      slidesPerView: 1.1, // Show 1 slide on mobile
      spaceBetween: 15,
	  pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
          nextEl: '.swiper-nav__right_dc-products',
          prevEl: '.swiper-nav__left_dc-products',
      },
      // Add breakpoints for responsiveness
      breakpoints: {
          576: {
              slidesPerView: 2,
          },
          992: {
              slidesPerView: 3,
              spaceBetween: 20, 
          },
          // Add more breakpoints as needed
      },
  });
   var ebusProductsSwiper = new Swiper('.carousel_ebus-etruck', {
      slidesPerView: 1.1, // Show 1 slide on mobile
      spaceBetween: 15,
	  pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
          nextEl: '.swiper-nav__right_ebus-etruck',
          prevEl: '.swiper-nav__left_ebus-etruck',
      },
      // Add breakpoints for responsiveness
      breakpoints: {
          576: {
              slidesPerView: 2,
          },
          992: {
              slidesPerView: 3, 
              spaceBetween: 20,
          },
          // Add more breakpoints as needed
      },
  });
  // Add event listener to the button to go to the first slide
    $('.nav-link').on('click', function() {
        acProductsSwiper.slideTo(0); // Go to the first slide
        dcProductsSwiper.slideTo(0); // Go to the first slide
        ebusProductsSwiper.slideTo(0); // Go to the first slide
    });
  
  //Swiper slider for Awards
  var awardsSwiper = new Swiper('.awards-carousel', {
      slidesPerView: 1.1, // Show 1 slide on mobile
      spaceBetween: 15,
	  pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
          nextEl: '.swiper-nav__right',
          prevEl: '.swiper-nav__left',
      },
      // Add breakpoints for responsiveness
      breakpoints: {
          // When window width is >= 576px (sm)
          576: {
              slidesPerView: 1.5, // Show 2 slides
          },
          // When window width is >= 768px (md)
          768: {
              slidesPerView: 1.5, // Show 3 slides
          },
		  991: {
              slidesPerView: 3, // Show 3 slides
              spaceBetween: 20,
          },
          // Add more breakpoints as needed
      },
  });
  
    //Swiper slider for Testimonial
  var testimonialSwiper = new Swiper('.testimonial-carousel', {
      slidesPerView: 1.2, // Show 1 slide on mobile
      spaceBetween: 15,
	  pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
          nextEl: '.swiper-nav__right',
          prevEl: '.swiper-nav__left',
      },
      // Add breakpoints for responsiveness
      breakpoints: {
          // When window width is >= 576px (sm)
          576: {
              slidesPerView: 1.5, // Show 2 slides
          },
          // When window width is >= 768px (md)
          768: {
              slidesPerView: 1.5, // Show 3 slides
          },
          991: {
              slidesPerView: 2.5, // Show 3 slides
              spaceBetween: 30,
          },
      },
  });
  // Hide image slider pagination if only one slide
	$('.testimonial-carousel').each(function() {
		if ($(this).find('.swiper-slide').length < 4) {
			$(this).closest('.container').find('.slider-meta').addClass('d-none')
		}; 
	});
  
    //Swiper slider for Case study Carousel
  var caseStudySwiper = new Swiper('.case_study-container', {
      slidesPerView: 1.1, // Show 1 slide on mobile
      spaceBetween: 15,
	  pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
          nextEl: '.swiper-nav__right',
          prevEl: '.swiper-nav__left',
      },
	  watchOverflow: true,
      // Add breakpoints for responsiveness
      breakpoints: {

          // When window width is >= 768px (md)
          768: {
              slidesPerView: 1, // Show 3 slides
          },
          991: {
              slidesPerView: 1, // Show 3 slides
          },
      },
  });

  
  // Add fraction pagination manually
  // For each instance of .case_study-container
	$('.case_study-container').each(function() {
		console.log('found');
		var $swiperSlides = $(this).find('.swiper-slide');
		// Check if there is more than one .swiper-slide
		if ($swiperSlides.length > 1) {
			// Find each .swiper-slide and get the aria-label value
			$swiperSlides.each(function() {
				var ariaLabel = $(this).attr('aria-label').replace(/\s/g, ''); // Remove spaces
				console.log(ariaLabel);
				$(this).find('.swiper-fraction').text(ariaLabel); // Add aria-label within the next .swiper-fraction
			});
		}
	});

    // Check each .swiper-wrapper
    $('.swiper-wrapper').each(function() {
      // Check if there is only one instance of .swiper-slide
      if ($(this).find('.swiper-slide').length === 1) {
        // Find the first instance of .slider-meta within the closest .row
        var firstSliderMeta = $(this).closest('.row').find('.slider-meta').first().addClass('disabled');
      }
    });
  
     //Swiper slider for Post navigation on home and cat
  var caseStudySwiper = new Swiper('.post-nav-container', {
      slidesPerView: 'auto',
      spaceBetween: 12,
	  pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
        nextEl: '.swiper-nav__right',
        prevEl: '.swiper-nav__left',
    },
	  // Add breakpoints for responsiveness
      breakpoints: {
          // When window width is >= 768px (md)
          768: {
              spaceBetween: 24,
          },
      },
  });
  
  //Swiper slider for Image Text block
  var imageTextSwiper = new Swiper('.image-carousel', {
	  autoHeight: true,
      slidesPerView: 1, // Show 1 slide on mobile
      spaceBetween: 10,
      navigation: {
          nextEl: '.swiper-nav__right',
          prevEl: '.swiper-nav__left',
      },
  });
  
  // Hide image slider pagination if only one slide
	$('.image-carousel').each(function() {
		if ($(this).find('.swiper-slide').length < 2) {
			$(this).find('.slider_nav').addClass('d-none')
		}; 
	});
  
  //Swiper slider for gallery slider
  
  var swiper = new Swiper(".gallery_navigation", {
      loop: true,
      spaceBetween: 5,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
	   breakpoints: {
          // When window width is >= 576px (sm)
          576: {
              slidesPerView: 5,
			  spaceBetween: 15,
          },
      },
    });
    var swiper2 = new Swiper(".gallery_slider", {
		 autoHeight: true,
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-nav__right',
        prevEl: '.swiper-nav__left',
      },
      thumbs: {
        swiper: swiper,
      },
    });
	
	// Hide gallery pagination if only one slide
	$('.gallery_slider').each(function() {
		if ($(this).find('.swiper-slide').length < 2) {
			$(this).find('.slider_nav').addClass('d-none')
		}; 
	});
	$('.gallery_navigation ').each(function() {
		if ($(this).find('.swiper-slide').length < 2) {
			$(this).addClass('d-none')
		}; 
	});
  
  //Glightbox for videos
  const lightbox = GLightbox({
        touchNavigation: false,
        loop: false,
        autoplayVideos: true,
      });

      lightbox.init();
	  
	  
	// Set google maps height
	
// Function to handle the resize event
  function handleResize() {
    // Check if the screen width is larger than 1200 pixels
    if ($(window).width() > 1200) {
      // Loop through each .acf-map element
      $('.acf-map').each(function() {
        // Find the closest .location-block
        var locationBlock = $(this).closest('.location-block');

        // Find .boxed within .location-block
        var boxed = locationBlock.find('.boxed');

        // Get the total height including padding
        var totalHeight = boxed.outerHeight(false);

        // Assign the total height to the corresponding .acf-map element
        $(this).height(totalHeight);

        // Optional: Log the total height for verification
        //console.log('Total height of .boxed including padding:', totalHeight);
      });
    } else {
      // If the screen width is not larger than 1200 pixels, reset the height
      $('.acf-map').height('400px');
    }
  }

  // Initial call to handleResize on page load
  handleResize();

  // Attach the handleResize function to the resize event
  $(window).resize(handleResize);
  
  $(function() {
	$('.match-height').matchHeight();
	$('.slider-height').matchHeight();
  $('.services-block .slider-content').matchHeight();
  $('.match-minheight').matchHeight({ property: 'min-height' });
});

});

//Service row scroll
if (jQuery(window).width() > 992) {
	jQuery(window).on('load', function () {
		jQuery('.horizscrollerwrap').each(function () {
			var theHeight = jQuery(this).find('.horizscrollerinner').outerWidth();
			// theHeight = theHeight + jQuery(window).width();
			// theHeight = theHeight + jQuery(window).height();
			// theHeight = theHeight + jQuery(window).width();
			// theHeight = theHeight + jQuery(this).find('.horizscrollerinner').outerHeight();



			var ttl = 0;
			jQuery('.elem').each(function () {
				ttl = ttl + jQuery(this).outerWidth();
			});

			console.log(ttl);




			jQuery(this).css('height', ttl - (jQuery(window).height() / 2));
			jQuery(this).find('.horizscrollerouter').css('top', 'calc(50vh - ' + (jQuery(this)
				.find('.horizscrollerouter').outerHeight() / 2) + 'px)');
		});
	});


	jQuery(window).scroll(function () {
		jQuery('.horizscrollerwrap').each(function () {
			var posTop = jQuery(window).scrollTop() - jQuery(this).offset().top;
			if (posTop <= 0) posTop = 0;
			if (posTop >= jQuery(this).outerHeight()) posTop = jQuery(this).outerHeight();
			jQuery(this).attr('postop', posTop);

			jQuery(this).find('.horizscrollerouter').scrollLeft(posTop);
		});
	});
}



// Add class to header when scrolled over 1px
jQuery(window).scroll(function() {
  if (jQuery(this).scrollTop() > 1) {
    jQuery('#wrapper-navbar').addClass('scrolled');
  } else {
    jQuery('#wrapper-navbar').removeClass('scrolled');
  }
});



jQuery(window).on('load', function() {
  console.log('RUN');
  jQuery('.slidervisual').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: true
  });
});

//  Change class of .slider-label on slide change matching it with the data-slideid attribute
jQuery('.slidervisual').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  // Note: 'nextSlide' is the index of the next slide that will be shown
  jQuery('.slider-label').removeClass('vactive');
  // Since 'beforeChange' gives us 'nextSlide', we use it directly
  jQuery('.slider-label[data-slideid="' + nextSlide + '"]').addClass('vactive');
});


jQuery('.slide-next').on('click', function(e) {
  e.preventDefault();
  jQuery(this).closest('.slidervisual').slick('slickNext');
});

jQuery('[data-slideid]').on('click', function(e) {
  e.preventDefault();
  var slideid = jQuery(this).attr('data-slideid');
  jQuery(this).closest('section').find('.slidervisual').slick('slickGoTo', slideid);
});

jQuery('ul.mega-menu>li.hassubmenu').mouseenter(function() {
  jQuery('header#wrapper-navbar').addClass('menu-hover');
});

jQuery('ul.mega-menu>li.hassubmenu').mouseleave(function() {
  jQuery('header#wrapper-navbar').removeClass('menu-hover');
});




jQuery(window).on('load', function() {
  jQuery('.burg').on('click', function(e) {
    e.preventDefault();
    jQuery('.slideoutmobilemenu').addClass('openmob');
  }); 
});


jQuery('.hadropped>a').on('click', function(e) {
  e.preventDefault();
  jQuery(this).parent().addClass('togglesubopoen');
  jQuery('.slideoutmobilemenu').addClass('opensubbed');
  
  jQuery('.accymenu').css('height', jQuery('.togglesubopen .dropperbit').outerHeight());

});

jQuery('.backbut').on('click', function(e) {
  e.preventDefault();
  jQuery(this).closest('.togglesubopoen').removeClass('togglesubopoen'); 
  jQuery('.accymenu').css('height', 'auto');
  jQuery('.opensubbed').removeClass('opensubbed');
});

jQuery('.clsbtn').on('click', function(e) {
  e.preventDefault();
  jQuery('.slideoutmobilemenu').removeClass('openmob');
  jQuery('.togglesubopoen').removeClass('togglesubopoen');
  jQuery('.slideoutmobilemenu').removeClass('opensubbed');
});


//  Scroll to next section when .homepage-hero .button[href=""] is clicked
jQuery('.homepage-hero .button[href=""]').on('click', function(e) {
  e.preventDefault();
  var nextSection = jQuery(this).closest('section').next().next('section');

  nextSection.addClass('herescroll');
  jQuery('html, body').animate({
    scrollTop: (nextSection.offset().top - jQuery('#wrapper-navbar').outerHeight() - 50)
  }, 0);
});


//   Slick slider for .cardsliderdesk that has 3 columns with dots for navigation
jQuery('.cardsliderdesk').not('.slick-initialized').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  dots: true,
  responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});


const $scrollableSection = jQuery('.simplecardslider');

let isDown = false; // Track if the mouse button is pressed
let startX; // Starting X coordinate of the mouse when clicking
let scrollLeft; // Left scroll position of the scrollable section

$scrollableSection.on('mousedown', function(e) {
  isDown = true;
  startX = e.pageX - jQuery(this).offset().left; // Get the initial click position
  scrollLeft = jQuery(this).scrollLeft(); // Get the initial scroll position
});

$scrollableSection.on('mouseleave', function() {
  isDown = false; // Cancel the scrolling if the mouse leaves the element
});

$scrollableSection.on('mouseup', function() {
  isDown = false; // Stop scrolling on mouse up
});

$scrollableSection.on('mousemove', function(e) {
  if (!isDown) return; // Only scroll when the mouse is pressed
  e.preventDefault(); // Prevent any text selection
  const x = e.pageX - jQuery(this).offset().left;
  const walk = (x - startX) * 1; // The scroll speed factor, adjust as necessary
  jQuery(this).scrollLeft(scrollLeft - walk);
});


jQuery(window).on('load', function() {
  jQuery('.gform_cont').css('height', jQuery('.gform_cont').outerHeight());
});


AOS.init({
  once: true
});

/* Mega menu */

document.addEventListener('DOMContentLoaded', function() {
    // Get all activation links
    const activateLinks = document.querySelectorAll('.activate-panel');
    const cards = document.querySelectorAll('.submenu-cards .card');

    activateLinks.forEach(link => {
        link.addEventListener('click', function() {
            // Get the index of the clicked link
            const cardIndex = this.getAttribute('data-card-index');
            
            // Remove is-selected class from all links and hide all cards
            activateLinks.forEach(l => l.classList.remove('is-selected'));
            cards.forEach(card => card.style.display = 'none');
            
            // Add is-selected class to clicked link and show the selected card
            this.classList.add('is-selected');
            const selectedCard = document.getElementById('card-' + cardIndex);
            if (selectedCard) {
                selectedCard.style.display = 'inline-block';
            }
        });
    });
});

/* Gated spotler submit */

jQuery(document).ready(function(){
  jQuery('.mail-block').on('change', '#input_4_1', function() {
      // Get the value of the email field in the first form
      let emailValue = jQuery(this).val();
      //console.log('Value is: ' + emailValue);

      // Navigate to the closest .form-container, then find the next .spotler, 
      // then look for a label containing "Email address" and get its 'for' attribute
      let targetEmailFieldId = jQuery(this)
          .closest('.newsletterform')               // Move up to the closest .form-container
          .find('.spotler')                         // Find the next .spotler
          .find('label:contains("Email address")')  // Locate the label with "Email address"
          .attr('for');                             // Get the 'for' attribute (ID of the input)

      // If we found the target email field ID, set its value
      if (targetEmailFieldId) {
          jQuery(`#${targetEmailFieldId}`).val(emailValue);
          jQuery(`#${targetEmailFieldId}`).attr('data-gtm-form-interact-field-id', '1');
      } else {
          console.log('Email field not found.');
      }
  });

// Click event for the Gravity Form submit button
  jQuery('#gform_submit_button_4').on('click', function(event) {
      event.preventDefault(); // Prevent default submission of the Gravity Form

  var secondForm = jQuery('#gform_4');
          if (secondForm.length) {
              secondForm.submit(); // Submit the Gravity Form
      }

      setTimeout(function() {
          var firstForm = jQuery('#form1203');
      if (firstForm.length) {
          // Submit the first form
          firstForm.submit(); 
      }
      }, 1000); // Adjust the delay time (in milliseconds) as necessary
  });
});
